import axios from 'axios';

export function resubmitCampaignContent(adId, payload, token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/advertiser/campaigns/${adId}/resubmit-content`,
        payload,
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
